// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colorPaletteSelector_Rup57 {
  background: #fff;
}

.tabsContainer_FTzdi {
  width: 100%;
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  padding: 4px;
  background-color: #f5f5f5;
  border-radius: 12px;
  box-sizing: border-box;
}

.tab_ttjO2 {
  background: transparent;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #999999;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-weight: 400;
  white-space: nowrap;
  flex: 1 1;
  width: auto;
  box-sizing: border-box;
}

.tab_ttjO2:hover {
  color: #666666;
}

.activeTab_CSaCG {
  background-color: #ffffff;
  color: #000000;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.colorValuesContainer_f_rZw {
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 12px;
  box-sizing: border-box;
}

.colorValueRow_tN3Ns {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 0;
}

.colorValueRow_tN3Ns:last-child {
  margin-bottom: 0;
}

.colorLabel_P5P6O {
  font-size: 0.95rem;
  color: #000000;
  font-weight: 500;
  letter-spacing: -0.01em;
  margin-bottom: 8px;
}

.colorValueDisplay_hm2Kd {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  background-color: #f5f5f5;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.colorValueDisplay_hm2Kd:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.colorDot_rrpyE {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.colorHex_TqzxH {
  font-size: 0.9rem;
  color: #666666;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', 'Consolas', monospace;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.grid_ZjFEp {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

.paletteItem_aqqKM {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
  background-color: var(--white-background);
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex: 1 1;
  min-width: 150px;
  box-sizing: border-box;
}

.paletteItem_aqqKM:hover {
  border-color: #b6b6b6;
}

.paletteItem_aqqKM.selected_oeaU5 {
  border-color: transparent;
  background-color: var(--f5-background);
}

.previewPlaceholder_oAkvn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin: 0 auto 8px auto;
  display: flex;
  overflow: hidden;
  border: 1px solid #eee;
}

.paletteName_Abftm {
  font-size: 0.8rem;
  color: #555;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: auto;
}

.colorCircle_mlFdC {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 auto;
  border: 2px solid #fff;
  box-shadow: 0 0 5px var(--_00000033-shadow);
}

@media (max-width: 1200px) {
  .colorValuesContainer_f_rZw {
    padding: 20px;
    margin-bottom: 20px;
  }

  .paletteItem_aqqKM {
    min-width: 140px;
    min-height: 90px;
  }
}

@media (max-width: 1024px) {
  .tabsContainer_FTzdi {
    margin-bottom: 20px;
    padding: 3px;
  }

  .tab_ttjO2 {
    padding: 10px 14px;
    font-size: 0.85rem;
  }

  .colorValuesContainer_f_rZw {
    padding: 18px;
    margin-bottom: 18px;
  }

  .colorLabel_P5P6O {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }

  .colorValueDisplay_hm2Kd {
    padding: 10px 14px;
    gap: 10px;
  }

  .colorDot_rrpyE {
    width: 18px;
    height: 18px;
  }

  .colorHex_TqzxH {
    font-size: 0.85rem;
  }

  .grid_ZjFEp {
    gap: 10px;
  }

  .paletteItem_aqqKM {
    min-width: 130px;
    min-height: 85px;
    padding: 8px;
  }

  .previewPlaceholder_oAkvn {
    width: 28px;
    height: 28px;
    margin: 0 auto 6px auto;
  }

  .colorCircle_mlFdC {
    width: 23px;
    height: 23px;
  }

  .paletteName_Abftm {
    font-size: 0.75rem;
  }
}

@media (max-width: 768px) {
  .tabsContainer_FTzdi {
    gap: 2px;
    padding: 2px;
    margin-bottom: 16px;
  }

  .tab_ttjO2 {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .colorValuesContainer_f_rZw {
    padding: 16px;
    margin-bottom: 16px;
  }

  .colorValueRow_tN3Ns {
    margin-bottom: 12px;
  }

  .colorLabel_P5P6O {
    font-size: 0.85rem;
    margin-bottom: 6px;
  }

  .colorValueDisplay_hm2Kd {
    padding: 8px 12px;
    gap: 8px;
  }

  .colorDot_rrpyE {
    width: 16px;
    height: 16px;
  }

  .colorHex_TqzxH {
    font-size: 0.8rem;
  }

  .grid_ZjFEp {
    gap: 8px;
  }

  .paletteItem_aqqKM {
    padding: 8px;
    min-height: 80px;
    flex: 1 1;
    min-width: 120px;
  }

  .previewPlaceholder_oAkvn {
    width: 20px;
    height: 20px;
    margin: 0 auto 6px auto;
  }

  .colorCircle_mlFdC {
    width: 18px;
    height: 18px;
  }

  .paletteName_Abftm {
    font-size: 0.7rem;
  }
}

@media (max-width: 600px) {
  .tabsContainer_FTzdi {
    flex-direction: column;
    gap: 4px;
  }

  .tab_ttjO2 {
    padding: 10px 12px;
    font-size: 0.85rem;
    text-align: center;
  }

  .colorValuesContainer_f_rZw {
    padding: 12px;
  }

  .paletteItem_aqqKM {
    min-width: 0;
    flex: 1 1;
    min-width: calc(50% - 4px); 
  }
}

@media (max-width: 480px) {
  .tabsContainer_FTzdi {
    gap: 4px;
  }

  .tab_ttjO2 {
    padding: 10px 8px;
    font-size: 0.9rem;
  }

  .colorValuesContainer_f_rZw {
    padding: 12px;
  }

  .colorValueDisplay_hm2Kd {
    padding: 6px 10px;
    gap: 6px;
  }

  .colorDot_rrpyE {
    width: 14px;
    height: 14px;
  }

  .colorHex_TqzxH {
    font-size: 0.75rem;
  }

  .paletteItem_aqqKM {
    min-width: calc(50% - 4px);
    min-height: 70px;
    padding: 6px;
  }

  .previewPlaceholder_oAkvn {
    width: 18px;
    height: 18px;
    margin: 0 auto 4px auto;
  }

  .colorCircle_mlFdC {
    width: 16px;
    height: 16px;
  }

  .paletteName_Abftm {
    font-size: 0.65rem;
  }
}

@media (max-width: 375px) {
  .tab_ttjO2 {
    padding: 8px 6px;
    font-size: 0.8rem;
  }

  .colorValuesContainer_f_rZw {
    padding: 10px;
  }

  .colorLabel_P5P6O {
    font-size: 0.8rem;
    margin-bottom: 4px;
  }

  .colorValueDisplay_hm2Kd {
    padding: 4px 8px;
    gap: 4px;
  }

  .colorDot_rrpyE {
    width: 12px;
    height: 12px;
  }

  .colorHex_TqzxH {
    font-size: 0.7rem;
  }

  .paletteItem_aqqKM {
    min-height: 60px;
    padding: 4px;
  }

  .previewPlaceholder_oAkvn {
    width: 16px;
    height: 16px;
    margin: 0 auto 2px auto;
  }

  .colorCircle_mlFdC {
    width: 14px;
    height: 14px;
  }

  .paletteName_Abftm {
    font-size: 0.6rem;
  }
}

@media (max-width: 320px) {
  .tabsContainer_FTzdi {
    gap: 2px;
  }

  .tab_ttjO2 {
    padding: 6px 4px;
    font-size: 0.75rem;
  }

  .colorValuesContainer_f_rZw {
    padding: 8px;
  }

  .paletteItem_aqqKM {
    min-width: calc(100% - 4px); 
    min-height: 50px;
    padding: 3px;
  }

  .previewPlaceholder_oAkvn {
    width: 14px;
    height: 14px;
  }

  .colorCircle_mlFdC {
    width: 12px;
    height: 12px;
  }

  .paletteName_Abftm {
    font-size: 0.55rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/ColorPaletteSelector/ColorPaletteSelector.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;EACP,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qFAAqF;EACrF,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,wDAAwD;EACxD,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,SAAO;IACP,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".colorPaletteSelector {\n  background: #fff;\n}\n\n.tabsContainer {\n  width: 100%;\n  display: flex;\n  gap: 4px;\n  margin-bottom: 24px;\n  padding: 4px;\n  background-color: #f5f5f5;\n  border-radius: 12px;\n  box-sizing: border-box;\n}\n\n.tab {\n  background: transparent;\n  border: none;\n  padding: 12px 16px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #999999;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  font-weight: 400;\n  white-space: nowrap;\n  flex: 1;\n  width: auto;\n  box-sizing: border-box;\n}\n\n.tab:hover {\n  color: #666666;\n}\n\n.activeTab {\n  background-color: #ffffff;\n  color: #000000;\n  font-weight: 500;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.colorValuesContainer {\n  margin-bottom: 24px;\n  padding: 24px;\n  border-radius: 12px;\n  box-sizing: border-box;\n}\n\n.colorValueRow {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  padding: 0;\n}\n\n.colorValueRow:last-child {\n  margin-bottom: 0;\n}\n\n.colorLabel {\n  font-size: 0.95rem;\n  color: #000000;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-bottom: 8px;\n}\n\n.colorValueDisplay {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 12px 16px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n  background-color: #f5f5f5;\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n}\n\n.colorValueDisplay:hover {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.colorDot {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: none;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n}\n\n.colorHex {\n  font-size: 0.9rem;\n  color: #666666;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', 'Consolas', monospace;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.grid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.paletteItem {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  padding: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  text-align: center;\n  background-color: var(--white-background);\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  flex: 1;\n  min-width: 150px;\n  box-sizing: border-box;\n}\n\n.paletteItem:hover {\n  border-color: #b6b6b6;\n}\n\n.paletteItem.selected {\n  border-color: transparent;\n  background-color: var(--f5-background);\n}\n\n.previewPlaceholder {\n  width: 30px;\n  height: 30px;\n  border-radius: 4px;\n  margin: 0 auto 8px auto;\n  display: flex;\n  overflow: hidden;\n  border: 1px solid #eee;\n}\n\n.paletteName {\n  font-size: 0.8rem;\n  color: #555;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: auto;\n}\n\n.colorCircle {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  margin: 0 auto;\n  border: 2px solid #fff;\n  box-shadow: 0 0 5px var(--_00000033-shadow);\n}\n\n@media (max-width: 1200px) {\n  .colorValuesContainer {\n    padding: 20px;\n    margin-bottom: 20px;\n  }\n\n  .paletteItem {\n    min-width: 140px;\n    min-height: 90px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .tabsContainer {\n    margin-bottom: 20px;\n    padding: 3px;\n  }\n\n  .tab {\n    padding: 10px 14px;\n    font-size: 0.85rem;\n  }\n\n  .colorValuesContainer {\n    padding: 18px;\n    margin-bottom: 18px;\n  }\n\n  .colorLabel {\n    font-size: 0.9rem;\n    margin-bottom: 6px;\n  }\n\n  .colorValueDisplay {\n    padding: 10px 14px;\n    gap: 10px;\n  }\n\n  .colorDot {\n    width: 18px;\n    height: 18px;\n  }\n\n  .colorHex {\n    font-size: 0.85rem;\n  }\n\n  .grid {\n    gap: 10px;\n  }\n\n  .paletteItem {\n    min-width: 130px;\n    min-height: 85px;\n    padding: 8px;\n  }\n\n  .previewPlaceholder {\n    width: 28px;\n    height: 28px;\n    margin: 0 auto 6px auto;\n  }\n\n  .colorCircle {\n    width: 23px;\n    height: 23px;\n  }\n\n  .paletteName {\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .tabsContainer {\n    gap: 2px;\n    padding: 2px;\n    margin-bottom: 16px;\n  }\n\n  .tab {\n    padding: 8px 12px;\n    font-size: 0.8rem;\n  }\n\n  .colorValuesContainer {\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .colorValueRow {\n    margin-bottom: 12px;\n  }\n\n  .colorLabel {\n    font-size: 0.85rem;\n    margin-bottom: 6px;\n  }\n\n  .colorValueDisplay {\n    padding: 8px 12px;\n    gap: 8px;\n  }\n\n  .colorDot {\n    width: 16px;\n    height: 16px;\n  }\n\n  .colorHex {\n    font-size: 0.8rem;\n  }\n\n  .grid {\n    gap: 8px;\n  }\n\n  .paletteItem {\n    padding: 8px;\n    min-height: 80px;\n    flex: 1;\n    min-width: 120px;\n  }\n\n  .previewPlaceholder {\n    width: 20px;\n    height: 20px;\n    margin: 0 auto 6px auto;\n  }\n\n  .colorCircle {\n    width: 18px;\n    height: 18px;\n  }\n\n  .paletteName {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .tabsContainer {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .tab {\n    padding: 10px 12px;\n    font-size: 0.85rem;\n    text-align: center;\n  }\n\n  .colorValuesContainer {\n    padding: 12px;\n  }\n\n  .paletteItem {\n    min-width: 0;\n    flex: 1;\n    min-width: calc(50% - 4px); \n  }\n}\n\n@media (max-width: 480px) {\n  .tabsContainer {\n    gap: 4px;\n  }\n\n  .tab {\n    padding: 10px 8px;\n    font-size: 0.9rem;\n  }\n\n  .colorValuesContainer {\n    padding: 12px;\n  }\n\n  .colorValueDisplay {\n    padding: 6px 10px;\n    gap: 6px;\n  }\n\n  .colorDot {\n    width: 14px;\n    height: 14px;\n  }\n\n  .colorHex {\n    font-size: 0.75rem;\n  }\n\n  .paletteItem {\n    min-width: calc(50% - 4px);\n    min-height: 70px;\n    padding: 6px;\n  }\n\n  .previewPlaceholder {\n    width: 18px;\n    height: 18px;\n    margin: 0 auto 4px auto;\n  }\n\n  .colorCircle {\n    width: 16px;\n    height: 16px;\n  }\n\n  .paletteName {\n    font-size: 0.65rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .tab {\n    padding: 8px 6px;\n    font-size: 0.8rem;\n  }\n\n  .colorValuesContainer {\n    padding: 10px;\n  }\n\n  .colorLabel {\n    font-size: 0.8rem;\n    margin-bottom: 4px;\n  }\n\n  .colorValueDisplay {\n    padding: 4px 8px;\n    gap: 4px;\n  }\n\n  .colorDot {\n    width: 12px;\n    height: 12px;\n  }\n\n  .colorHex {\n    font-size: 0.7rem;\n  }\n\n  .paletteItem {\n    min-height: 60px;\n    padding: 4px;\n  }\n\n  .previewPlaceholder {\n    width: 16px;\n    height: 16px;\n    margin: 0 auto 2px auto;\n  }\n\n  .colorCircle {\n    width: 14px;\n    height: 14px;\n  }\n\n  .paletteName {\n    font-size: 0.6rem;\n  }\n}\n\n@media (max-width: 320px) {\n  .tabsContainer {\n    gap: 2px;\n  }\n\n  .tab {\n    padding: 6px 4px;\n    font-size: 0.75rem;\n  }\n\n  .colorValuesContainer {\n    padding: 8px;\n  }\n\n  .paletteItem {\n    min-width: calc(100% - 4px); \n    min-height: 50px;\n    padding: 3px;\n  }\n\n  .previewPlaceholder {\n    width: 14px;\n    height: 14px;\n  }\n\n  .colorCircle {\n    width: 12px;\n    height: 12px;\n  }\n\n  .paletteName {\n    font-size: 0.55rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorPaletteSelector": `colorPaletteSelector_Rup57`,
	"tabsContainer": `tabsContainer_FTzdi`,
	"tab": `tab_ttjO2`,
	"activeTab": `activeTab_CSaCG`,
	"colorValuesContainer": `colorValuesContainer_f_rZw`,
	"colorValueRow": `colorValueRow_tN3Ns`,
	"colorLabel": `colorLabel_P5P6O`,
	"colorValueDisplay": `colorValueDisplay_hm2Kd`,
	"colorDot": `colorDot_rrpyE`,
	"colorHex": `colorHex_TqzxH`,
	"grid": `grid_ZjFEp`,
	"paletteItem": `paletteItem_aqqKM`,
	"selected": `selected_oeaU5`,
	"previewPlaceholder": `previewPlaceholder_oAkvn`,
	"paletteName": `paletteName_Abftm`,
	"colorCircle": `colorCircle_mlFdC`
};
export default ___CSS_LOADER_EXPORT___;
